import React from 'react';
import PropTypes from 'prop-types';

export class Modal extends React.Component {
  render() {
    // Render nothing if the "show" prop is false
    if(!this.props.show) {
      return null;
    }

    // The gray background
    const backdropStyle = {
      position: 'fixed',
      zIndex: 9999,
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      backgroundImage: `linear-gradient(to bottom, rgba(58,58,57, .66), rgba(0,0,0, .66))`,
      padding: 50,
    };

    // The modal "window"
    const modalStyle = {
      margin: '0 auto',
    };
    if(this.props.maxWidth !== undefined){
      modalStyle.width = (parseInt(this.props.maxWidth.split("px")[0], 10) * .9);
    }

    return (
      <div className="backdrop" style={backdropStyle}>
        <div className="modal" style={modalStyle}>
          {this.props.children}
        </div>
      </div>
    );
  }
}

Modal.propTypes = {
  onClose: PropTypes.func,
  show: PropTypes.bool,
  children: PropTypes.node
};



// WEBPACK FOOTER //
// ./src/components/modal.js